<template>
  <div class="bg-light bbg-soft-indigo pt-4 pb-2">
    <div class="container">
      <h3>{{ message }}</h3>
      <div class="row">
        <div v-for="item in shoppingBasket" :key="item.uid" class="col-md-3 mb-3">
          <ProductCardSmall :product="item" enable-delete :enable-select="enableSelect"
                            :selected="isSelected(item)"
                            @deleted="removeFromShoppingBasket($event)" 
                            @selected="selectItem($event)"
                            @deselected="deselectItem($event)"
                            @view="viewProduct($event)">
          </ProductCardSmall>
        </div>
      </div>
      <button v-if="shoppingBasket.length === 2 || shoppingBasket.length === 3" @click="compareProducts()" class="btn btn-soft-primary w-100">Compare these deals...</button>
      <button v-if="shoppingBasket.length > 3" 
              @click="compareProducts()" 
              :disabled="totalSelected < 2 || totalSelected > 3" 
              class="btn btn-soft-primary w-100">
        {{ totalSelected !== 3 ? 'Select up to 3 products to compare...' : 'Compare selected products...' }}
      </button>
      <div class="text-center mt-3">
        <span class="divider divider-text">
          <button class="btn btn-sm btn-ghost-primary" @click="closeBasket()">Close</button>
        </span>
      </div>
    </div>
    <b-modal @hidden="closeComparison()" @close="closeComparison()" :visible="showComparison" size="xl" name="productComparisonModal" id="product-comparison-modal" hide-footer>
      <template v-slot:modal-title>
        <h3 class="modal-title">Compare Products</h3>
      </template>
      <div class="d-block">
        <CompareProducts :products="selectedProducts"></CompareProducts>
      </div>
      <button class="btn btn-soft-secondary btn-sm mt-3" @click="closeComparison()">Close</button>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CompareProducts from "@/components/products/CompareProducts";
import ProductCardSmall from "@/components/products/ProductCardSmall";
export default {
  name: "ShoppingBasket",
  
  components: {
    ProductCardSmall,
    CompareProducts
  },
  
  data() {
    return {
      showComparison: false,
      selected: []
    }
  },
  
  methods: {
    closeComparison() {
      this.showComparison = false;
    },
    
    compareProducts() {
      this.showComparison = true;
    },
    
    isSelected(item) {
      return this.shoppingBasket.length < 4 ? false : this.selected.find(i => i.uid === item.uid) != null;
    },
    
    deselectItem(item) {
      this.selected = this.selected.filter(i => i.uid !== item.uid);  
    },
    
    selectItem(item) {
        this.selected.push(item);
    },
    
    viewProduct(item) {
      this.$emit("view-product", item);
    },

    removeFromShoppingBasket(item) {
      this.$emit("remove-product", item);
    },
    
    closeBasket() {
      this.$emit('close-basket');
    }
  },

  computed: {
    ...mapGetters([
      "shoppingBasket"
    ]),
    
    selectedProducts() {
      return this.totalSelected === 0 ? this.shoppingBasket : this.selected;
    },
    
    totalSelected() { return this.selected.length; },
    
    enableSelect() {
      return this.shoppingBasket.length > 3;
    },
    
    message() {
      return this.shoppingBasket.length === 0 ? "You have no items in your basket."
          : this.shoppingBasket.length === 1 ? "You have the following item in your basket."
          : "You have the following items in your basket."
      
    }
  }
}
</script>

<style scoped>

</style>